<script lang="ts">
	//Hooks
	import { onMount } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Helpers
	import { digitFormat } from '../../../helpers/date_helper';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	import { home_data } from 'src/stores/account/user';
	// Design system components
	import { Row, Col, Button, Select } from '@Shelly/shelly-design-system';
	import type { SelectOptionType } from '@Shelly/shelly-design-system';
	import { get } from 'svelte/store';
	import { capFirstChar } from 'src/helpers/utilities';

	let value: SelectOptionType = {
		title: $format('of_the_month', {
			default: '{day} of the month',
			values: { day: $home_data.billing_date || '' },
		}),
		value: $home_data.billing_date || '',
	};
	const options = [];

	onMount(() => {
		for (let i = 1; i <= 28; i++) {
			options.push({
				value: i,
				title: $format('of_the_month', {
					values: {
						day: digitFormat(i),
					},
					default: digitFormat(i) + ' of the month',
				}),
			});
		}
		const billingDate = get(home_data)?.billing_date || 1;
		value = options[billingDate - 1];
	});

	const setBillingDate = async () => {
		const date = value['value'],
			id = 'billing_date',
			res = await postReq('/interface/home/save', {
				data: date,
				id,
			});
		if (res?.isok) {
			home_data.update((home_data) => {
				home_data[id] = date;
				return home_data;
			});
		}
		onSettingsResponse(res);
	};
</script>

<Row>
	<Col xs="12" md="3">
		<Select
			{options}
			bind:value
			label={capFirstChar($format('selection_date', { default: 'Date' }))}
			icon={'fas fa-calendar-check'}
			size="m"
			id="select-0c5b6eo"
			aria-labelledby="select-0c5b6eo"
		/>
	</Col>
	<Col xs="12" md="3">
		<Button size="m" class="text-capitalize width-md-auto width-sm-full" on:click={setBillingDate}
			>{$format('button_save', { default: 'save' })}</Button
		>
	</Col>
</Row>
